'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--EmojiFlirt';

var EntypoEmojiFlirt = function EntypoEmojiFlirt(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M7.5,9.75C8.329,9.75,9,8.967,9,8S8.329,6.25,7.5,6.25S6,7.034,6,8S6.672,9.75,7.5,9.75z M10,0.4C4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601C19.6,4.698,15.301,0.4,10,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6S17.6,5.802,17.6,10C17.6,14.197,14.197,17.599,10,17.599z M14.341,11.336c-0.363-0.187-0.815-0.043-1.008,0.32c-0.034,0.065-0.869,1.593-3.332,1.593c-2.451,0-3.291-1.513-3.333-1.592c-0.188-0.365-0.632-0.514-1.004-0.329c-0.37,0.185-0.521,0.636-0.335,1.007c0.05,0.099,1.248,2.414,4.672,2.414c3.425,0,4.621-2.316,4.67-2.415C14.855,11.967,14.707,11.524,14.341,11.336z M11.25,8.75h2.5c0.414,0,0.75-0.336,0.75-0.75c0-0.414-0.336-0.75-0.75-0.75h-2.5c-0.414,0-0.75,0.336-0.75,0.75C10.5,8.415,10.836,8.75,11.25,8.75z' })
    );
};

exports.default = EntypoEmojiFlirt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-entypo-icons/lib/entypo/EmojiFlirt.js
// module id = 7331
// module chunks = 0